import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export type CalibrationStatus = 'PENDING' | 'NOT_REQUIRED' | 'COMPLETE';

export const updateCalibrationStatus = ({
  employeeIds,
  calibrationStatus,
  reviewCycleId,
}: {
  employeeIds: number[];
  calibrationStatus: CalibrationStatus;
  reviewCycleId: number;
}) => {
  const url = endpoints.performanceReview.manage.updateCalibrationStatus;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      employeeIds,
      calibrationStatus,
      reviewCycleId,
    },
    queryParams: {},
  });
};
